import axios from 'axios';
import { retrieveAccessToken } from '../../../../shared/infra/auth/RetrieveAccessToken.jsx';

const findDraftById = async (draftId) => {
    if (!draftId) {
        throw new Error("Invalid draftId");
    }

    try {
        const accessToken = await retrieveAccessToken();
        const response = await axios.get(`/api/editor/draft/${draftId}`, {
            headers: {
                ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
            }
        });
        if (!response.data) {
            throw new Error("No data received");
        }
        return response.data;
    } catch (error) {
        throw new Error(
            error.response
                ? `Error fetching draft: ${error.response.status} ${error.response.statusText}`
                : error.message
        );
    }
};

export { findDraftById };